import { SVGProps, Ref, forwardRef } from 'react';

export const BriefcaseOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M5.665 10.932h4.666v-1.4H5.665z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.399 3.511C.575 3.615 0 4.497 0 8.832v1.333c0 4.666.667 5.332 5.332 5.332h5.332c4.666 0 5.332-.666 5.332-5.332V8.832c0-4.335-.575-5.217-4.399-5.32C11.067 1.783 9.96.5 7.998.5S4.929 1.784 4.399 3.511m1.487-.01h4.224a4 4 0 0 0-.212-.446c-.415-.749-.982-1.155-1.9-1.155s-1.485.406-1.9 1.155a4 4 0 0 0-.212.445M1.4 10.164c0 1.156.043 1.96.153 2.542.107.568.252.783.353.884s.316.246.884.353c.581.11 1.386.153 2.542.153h5.332c1.156 0 1.96-.043 2.542-.153.568-.107.783-.252.884-.353s.246-.316.353-.884c.11-.581.153-1.386.153-2.542V8.832q0-.373-.006-.7H1.406q-.006.327-.006.7zM14.443 6.29q.038.202.066.442H1.487q.028-.24.066-.442c.107-.568.252-.782.353-.883s.316-.247.884-.354c.581-.11 1.386-.153 2.542-.153h5.332c1.156 0 1.96.043 2.542.153.568.107.783.253.884.354s.246.315.353.883"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
BriefcaseOutlinedSize16Glyph.displayName = 'BriefcaseOutlinedSize16Glyph';
